import React from "react";
import { connect } from "react-redux";
import constants from "constants";
import axios from "axios";
import FileSaver from "file-saver";
import moment from "moment";

const getTitles = (userType, showId) => {
  if (userType === "pharmaceutical") {
    return [
      "No.",
      "Title",
      "First Name",
      "Last Name",
      "User Type",
      showId ? "Accreditation Number" : "",
    ];
  }

  return [
    "No.",
    "Title",
    "First Name",
    "Last Name",
    "User Type",
    "County",
    showId ? "Accreditation Number" : "",
  ].filter(Boolean);
};

const getViewedTitles = (userType, showId) => {
  if (userType === "pharmaceutical") {
    return [
      "No.",
      "Title",
      "First Name",
      "Last Name",
      "User Type",
      showId ? "Accreditation Number" : "",
      "Viewed",
    ];
  }

  return [
    "No.",
    "Title",
    "First Name",
    "Last Name",
    "User Type",
    "County",
    showId ? "Accreditation Number" : "",
    "Viewed",
  ].filter(Boolean);
};

const { API_EXPORT_WEBINAR_USERS, API_EXPORT_WEBINAR_USERS_CSV, ROLES } =
  constants;

class UsersPopup extends React.Component {
  downloadPDFFile = (type) => {
    const { workshop, modalHide } = this.props;
    const url = `${API_EXPORT_WEBINAR_USERS}/${workshop.id}?statistic_type=${type}`;

    axios
      .get(url, {
        responseType: "blob",
      })
      .then((response) => {
        const effectiveFileName = "webinar_users.pdf";
        FileSaver.saveAs(response.data, effectiveFileName);
        modalHide();
      })
      .catch((error) => {});
  };

  downloadCSVFile = (type) => {
    const { workshop, modalHide } = this.props;
    const url = `${API_EXPORT_WEBINAR_USERS_CSV}/${workshop.id}?statistic_type=${type}`;

    axios
      .get(url, {
        responseType: "blob",
      })
      .then((response) => {
        const effectiveFileName = "webinar_users.csv";
        FileSaver.saveAs(response.data, effectiveFileName);
        modalHide();
      })
      .catch((error) => {});
  };

  userItem = (user, index, statistic_type, showId) => (
    <tr key={user.id}>
      <td>{index + 1}</td>
      <td>{user.title}</td>
      <td>{user.first_name}</td>
      <td>{user.last_name}</td>
      <td>{ROLES[user.user_type]}</td>
      <td>{user.county}</td>
      {showId ? <td>{user.id_number}</td> : null}
      {statistic_type === "viewed" ? (
        <td>{moment(user.viewed_at).format("DD/MM/YYYY hh:mmA")}</td>
      ) : null}
    </tr>
  );

  userPharmaItem = (user, index, statistic_type, showId) => (
    <tr key={user.id}>
      <td>{index + 1}</td>
      <td>{user.title}</td>
      <td>{user.first_name}</td>
      <td>{user.last_name}</td>
      <td>{ROLES[user.user_type]}</td>
      {showId ? <td>{user.id_number}</td> : null}
      {statistic_type === "viewed" ? (
        <td>{moment(user.viewed_at).format("DD/MM/YYYY hh:mmA")}</td>
      ) : null}
    </tr>
  );

  render() {
    const { workshop, statistic_type, users, user } = this.props;

    const showId = user.show_id_number;

    return (
      <div className="admin_user_table admin_table">
        <div style={{ display: "flex", gap: 15, justifyContent: "center" }}>
          <button
            onClick={() => this.downloadPDFFile(statistic_type)}
            disabled={users.length <= 0}
            className="btn-download-csv"
          >
            download PDF file
          </button>
          <button
            onClick={() => this.downloadCSVFile(statistic_type)}
            disabled={users.length <= 0}
            className="btn-download-csv"
          >
            download CSV file
          </button>
        </div>
        <h2 className="workshop_title_stats">{workshop.webinar_title}</h2>
        <div style={{ maxHeight: "450px", overflow: "auto" }}>
          <table>
            <tr>
              {statistic_type === "viewed"
                ? getViewedTitles(user.sponsor_type, showId).map((title) => (
                    <th key={title}>{title}</th>
                  ))
                : getTitles(user.sponsor_type, showId).map((title) => (
                    <th key={title}>{title}</th>
                  ))}
            </tr>

            {users.map((userItem, index) =>
              user.sponsor_type === "pharmaceutical"
                ? this.userPharmaItem(userItem, index, statistic_type, showId)
                : this.userItem(userItem, index, statistic_type, showId)
            )}
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  popupProps: state.modal.modalContentProps.additional,
  workshop: state.stats.workshop,
  statistic_type: state.stats.statistic_type,
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UsersPopup);



// WEBPACK FOOTER //
// ./src/containers/StatsLocker/UsersPopup.js